import { render, staticRenderFns } from "./UploadFlatFile.vue?vue&type=template&id=7b55efbe"
import script from "./UploadFlatFile.vue?vue&type=script&lang=js"
export * from "./UploadFlatFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b55efbe')) {
      api.createRecord('7b55efbe', component.options)
    } else {
      api.reload('7b55efbe', component.options)
    }
    module.hot.accept("./UploadFlatFile.vue?vue&type=template&id=7b55efbe", function () {
      api.rerender('7b55efbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/UploadFlatFile.vue"
export default component.exports